// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";

import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
// import { menuPanelRowStyles } from "@store/Themes/common/mixins/menu"; // Store Custom Code
// import { buttonResetProps } from "@store/Themes/common/props/button"; // Store Custom Code
// import { menuPanelProps } from "@store/Themes/common/props/menu"; // Store Custom Code
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { menuPanelRowResetStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
/* Store Custom Code - End */

const panelMenu: Styleguide["panelMenu"] = {
    /* Store Custom Code */
};

export default panelMenu;
